export default __webpack_public_path__ + "static/media/background.c178e9b3.png";